import './404.css';
import { Header } from "../../components/widgets/header/header";

export function init404Page() {
  Header.init();
}